import { useEffect } from 'react';

/**
 * Favicon propre à l'instance (agence). `index.html` n'en déclare aucune :
 * la plateforme sert plusieurs agences derrière le même build, une favicon
 * figée dans le HTML serait celle de la dernière agence à avoir déployé.
 * Sans réglage, le navigateur garde son comportement par défaut.
 */
export function useFavicon(url: string | undefined): void {
  useEffect(() => {
    if (!url) return;
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [url]);
}
